@if (!success) {
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''" [style.background]="isRightSideContent ? 'transparent' : null">
    @if (customerName) {
      <tidy-row [align]="'center'">
        <tidy-text [header]="('Hi ' | translate) + customerName + '!'" />
      </tidy-row>
    }

    <tidy-row [align]="'center'">
      <tidy-text [body]="'Please add your payment method below.'" />
    </tidy-row>

    <tidy-card>
      <tidy-row />
      <form [formGroup]="form">
        <div class="inline-form-row">
          <tidy-input
            [label]="'First Name'"
            formControlName="firstName"
            [form]="form.controls.firstName"
            [icon]="'assets/svg/person-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter your first name.'"
          />
          <tidy-input
            [label]="'Last Name'"
            formControlName="lastName"
            [form]="form.controls.lastName"
            [icon]="'assets/svg/person-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter your last name.'"
          />
        </div>
      </form>
      <tidy-row class="card-info-section">
        <tidy-text [body]="'Enter Card Information'" />
      </tidy-row>
      <div class="form-row">
        <form>
          <div id="card-info" #cardInfo></div>
        </form>
      </div>
    </tidy-card>

    <tidy-error-message [text]="errorMessage" />

    <div style="display: flex; align-content: center; justify-content: center">
      <re-captcha (resolved)="captchaEvents($event)" />
    </div>

    <tidy-row>
      <tidy-button
        [text]="'Save Payment Method'"
        [action]="boundSubmitCard"
        class="primary"
        [disabled]="submitting" />
    </tidy-row>
  </tidy-wrapper>
}

@if (success) {
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''" [style.background]="isRightSideContent ? 'transparent' : null">
    <tidy-card>
      <tidy-row [align]="'center'" class="extra-bottom-padding">
        <tidy-image [src]="'assets/svg/checkmark-circle.svg'" style="width: 48px; height: 48px; filter: invert(1);" />
      </tidy-row>
      <tidy-row [align]="'center'">
        <tidy-text [header]="'Payment Method Added!'" />
      </tidy-row>
      @if (cardLast4) {
        <tidy-row [align]="'center'">
          <tidy-text [body]="('Your card ending in •••• ' | translate) + cardLast4 + (' was saved successfully.' | translate)" />
        </tidy-row>
      } @else {
        <tidy-row [align]="'center'">
          <tidy-text [body]="'Your card was saved successfully.'" />
        </tidy-row>
      }
      <tidy-row [align]="'center'">
        <tidy-text [helper]="'You can now close this page.'" />
      </tidy-row>
    </tidy-card>
  </tidy-wrapper>
}
